// Shared `getNextPageParam` for the paginated list endpoints, which all answer
// with the same { total, per_page, page } pagination block.
export const getNextPageParam = (lastPage: any): number | undefined => {
  const pagination = lastPage?.pagination;
  if (!pagination) {
    return undefined;
  }
  if (pagination.per_page * pagination.page >= pagination.total) {
    // Return undefined here so hasNextPage equals to false
    return undefined;
  }
  return pagination.page + 1;
};
